<template>
  <div v-if="links && links.length > 0">
    <slot name="title"></slot>

    <div class="mt-16 flex flex-wrap gap-8 overflow-x-auto">
      <RevButton
        v-for="link in links"
        :key="link.title"
        data-selector="product-tag"
        size="small"
        :to="link.relativeLink"
        variant="primary"
        @click="handleLinkClick(link.relativeLink)"
      >
        {{ link.title }}
      </RevButton>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useTracking } from '@backmarket/nuxt-module-tracking/useTracking'
import { RevButton } from '@ds/components/Button'

import type { LinkBooster } from '~~/shared/api/internal-links/types'

const { trackClick } = useTracking()

defineProps<{
  links: LinkBooster[]
}>()

function handleLinkClick(target: string) {
  trackClick({ zone: 'tags', name: `product-tag-${target}` })
}
</script>
